import work_equipment_form from "../../../../view/ppr/work_equipments/form";

export default {
  work_equipment_form: work_equipment_form,
};
